export const ACTION_CONSTS = {
  OPEN_CREATE_DEFECT_DIALOG: 'OPEN_CREATE_DEFECT_DIALOG',
  CLOSE_CREATE_DEFECT_DIALOG: 'CLOSE_CREATE_DEFECT_DIALOG',
};

export const STATE_KEYS = {
  IS_OPEN: 'isOpen',
  DEFAULT_NAME: 'defaultName',
};
